import React from 'react';

export default (props) => (
  <div className='questionLabel'>
    <span className='label'>{ props.text }</span>
    {props.selectAll && <span className='multipleChoice'>( Select all that apply )</span>}
  </div>);